import {Component} from '@angular/core';

@Component({
    selector: 'tfl-gentelella-modal-body',
    template: `
        <div class="modal-body">
            <ng-content></ng-content>
        </div>
    `
})
export class GentelellaModalBodyComponent {
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/modal/modal-body.component.ts